import classNames from 'classnames'
import { SIcon } from 'components/directive/directiveSteppedGuide/styled'
import { DirectiveGuideStep } from 'components/directive/utils/types'
import { Picture } from 'components/picture/Picture'
import { SquooshedPictureKey } from 'components/picture/pictures'

export const DirectiveGuideStepVisual = ({
  step,
  isTutorial,
}: {
  step?: DirectiveGuideStep
  isTutorial?: boolean
}) => {
  if (!step) return null

  return (
    <>
      {!isTutorial && (
        <Picture
          imageKey={step.illustration as SquooshedPictureKey}
          sizes={'350px'}
          className="desktop-only"
        />
      )}
      {!!step.icon && (
        <SIcon name={step.icon} className={classNames(!isTutorial && 'mobile-only')} />
      )}
    </>
  )
}
